import React from 'react'
import { string, bool, func, shape } from 'prop-types'

import * as Style from './PlanSelector.style'

export default function PlanItem({
  label,
  pastSelected,
  selected,
  onClick,
  disabled,
  theme,
}) {
  return (
    <Style.PlanSelectorItem
      pastSelected={pastSelected}
      selected={selected}
      disabled={disabled}
      theme={theme}
      onClick={onClick}
    >
      <span>{label}</span>
    </Style.PlanSelectorItem>
  )
}

PlanItem.propTypes = {
  pastSelected: bool.isRequired,
  selected: bool.isRequired,
  label: string.isRequired,
  onClick: func.isRequired,
  disabled: bool,
  theme: shape({
    span: shape({
      backgroundColor: string,
    }),
  }),
}

PlanItem.defaultProps = {
  disabled: false,
  theme: {
    span: {
      backgroundColor: '',
    },
  },
}
